module.exports = __webpack_public_path__ + "static/media/brujula-es.86069401.svg";